import * as Sentry from '@sentry/gatsby'
import Cookies from 'js-cookie'
import {
  GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME,
  GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME,
} from './src/lib/global'

// Mirror analyticsCookiesDeclined() from src/components/analytics.ts, kept
// lightweight here so initialising Sentry does not pull react-ga/gtm into the
// startup bundle. Returns true only when the user has explicitly declined.
const analyticsCookiesDeclined = () => {
  if (typeof document === 'undefined') return false
  const values = [
    Cookies.get(GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME),
    Cookies.get(GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME),
  ].filter((value) => value !== undefined)
  return values.length > 0 && values.every((value) => value === 'false')
}

// Skip init entirely for returning visitors who previously declined. First-time
// visitors (no cookie yet) still initialise; teardownSentry() stops it if they
// then decline on the banner.
if (process.env.GATSBY_SENTRY_DSN && !analyticsCookiesDeclined()) {
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 0.5 to capture 5%
    // of transactions for tracing.
    tracesSampleRate: 0.05,

    // Capture Replay for 5% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

// Flush and disable the Sentry client (stops tracing and session replay) when
// the user declines on the cookie banner after Sentry has already initialised.
export const teardownSentry = () => Sentry.close()
